import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function Highlight5({data}) {
    const {highlight5Text, highlight5Title} = data
    return (
        <div className='our-imapct-video-wrap team-center-c-wrap light-grey-bg'>
            <div className='container sm-container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon'>
                            <StaticImage src='../../../images/origins-icon.png' alt='image' />
                        </figure>
                        <h2 className='heading-level-4-i text-uppercase green-color-1'>
                            {highlight5Title && parser(highlight5Title)}
                        </h2>
                        <p>{highlight5Text && parser(highlight5Text)}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
